import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { apiAssessors } from 'helpers/decorators/api'
import { meta, permissions } from 'helpers/decorators'
import { connect } from 'react-redux'
import { modal } from '../../../redux/modules/app'
import { FormattedMessage } from 'react-intl'
import { SubTab, SubTabs } from '../../../components/layout'
import AssessorsWaitingActivityAuthorizationActivity from './AssessorsWaitingActivityAuthorizationActivity'
import AssessorsWaitingActivityAuthorizationAJ from './AssessorsWaitingActivityAuthorizationAJ'
import AssessorsWaitingActivityAuthorizationRP from './AssessorsWaitingActivityAuthorizationRP'

@meta({
  title: 'Assessors',
  intlKey: 'route.assessors'
})
@permissions()
@connect(
    () => ({}),
    { modal }
)
class AssessorsWaitingActivityAuthorization extends Component {
  static propTypes = {
    inviteAssessor: PropTypes.func.isRequired
  }

  render() {
    return (
      <div>
        <div style={{ padding: "10px"}}>
          <FormattedMessage
            className="control-label"
            id="label.assessor_act_authorization_desc"
            defaultMessage="Assessor waiting activity authorization description"
          />
        </div>
        <SubTabs>
          <SubTab
            title="Activity"
            intlKey="tabs.activity"
          >
            <AssessorsWaitingActivityAuthorizationActivity />
          </SubTab>
          <SubTab
            title="Adventure Journey"
            intlKey="tabs.adventurous_journey"
          >
            <AssessorsWaitingActivityAuthorizationAJ />
          </SubTab>
          <SubTab
            title="Residential Project"
            intlKey="tabs.residential_project"
          >
            <AssessorsWaitingActivityAuthorizationRP />
          </SubTab>
        </SubTabs>
      </div>
    )
  }
}

export default AssessorsWaitingActivityAuthorization
